export enum ProgramParticipantTag {
  PURE_BUYER = "PURE_BUYER",
  SOCIAL_BUYER = "SOCIAL_BUYER",
  MEETING_REP = "MEETING_REP",
  TABLETALK_MODERATOR = "TABLETALK_MODERATOR",
  SOCIALIZER = "SOCIALIZER",
  EXHIBITOR = "EXHIBITOR"
}

export const BuyerProgramParticipantTagsList = [ProgramParticipantTag.PURE_BUYER, ProgramParticipantTag.SOCIAL_BUYER];
